export function Star() {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2291 1.37355C12.9783 -0.0537003 15.0217 -0.0537003 15.7709 1.37355L18.8185 7.17946L25.3575 8.10727C27.0218 8.34341 27.67 10.4028 26.441 11.5497L21.7965 15.8839L22.8937 22.1087C23.1782 23.7229 21.5068 24.9752 20.0376 24.2487L14 21.2635L7.96242 24.2487C6.49317 24.9752 4.82183 23.7229 5.10633 22.1087L6.2035 15.8839L1.55898 11.5496C0.330006 10.4028 0.978237 8.34341 2.64254 8.10727L9.1815 7.17946L12.2291 1.37355Z"
        fill="#93BDDA"
      />
    </svg>
  );
}
